import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Mail, MessageSquare } from 'lucide-react';
import { toast } from 'sonner';
import { useState } from 'react';

const Contact = () => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      toast.success('Message sent! We\'ll get back to you soon.');
      setLoading(false);
      e.target.reset();
    }, 1000);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <div className="flex-1 py-24">
        <div className="container mx-auto max-w-2xl">
          <div className="text-center mb-16">
            <Badge className="mb-4" variant="secondary">Contact</Badge>
            <h1 className="text-4xl md:text-5xl font-heading font-black tracking-tighter mb-6">
              Get in Touch
            </h1>
            <p className="text-lg text-muted-foreground">
              Have questions? We'd love to hear from you.
            </p>
          </div>

          <Card className="p-8 border-zinc-200">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium mb-2">Name</label>
                <Input placeholder="Your name" required data-testid="contact-name-input" />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Email</label>
                <Input type="email" placeholder="your@email.com" required data-testid="contact-email-input" />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Message</label>
                <Textarea placeholder="Your message..." rows={6} required data-testid="contact-message-input" />
              </div>

              <Button type="submit" className="w-full" disabled={loading} data-testid="contact-submit-btn">
                {loading ? 'Sending...' : 'Send Message'}
              </Button>
            </form>
          </Card>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
            <Card className="p-6 text-center border-zinc-200">
              <Mail className="h-8 w-8 mx-auto mb-2 text-primary" />
              <h3 className="font-heading font-bold mb-1">Email</h3>
              <p className="text-sm text-muted-foreground">support@proseshield.com</p>
            </Card>

            <Card className="p-6 text-center border-zinc-200">
              <MessageSquare className="h-8 w-8 mx-auto mb-2 text-primary" />
              <h3 className="font-heading font-bold mb-1">Live Chat</h3>
              <p className="text-sm text-muted-foreground">Available 9am-5pm EST</p>
            </Card>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Contact;
